<div fxLayout="row" fxLayoutAlign='space-between center'>
	<h3 appMargin marginB="0">Company Documents</h3>
	<button (click)="addDocument()" class="ui tiny icon button" >
		<i class="plus icon"></i>
		</button>
	</div>
	<hr>

<div class="ui vertical basic segment">
	<ng-template ngFor let-document [ngForOf]="documents" >
	<div fxLayout="row" fxLayoutAlign='space-between center'>
		<div fxFlex="grow">
			<h4 class="sub-header">{{document?.name}}</h4>
			<div class="sub-item">Date Created <label class="ui circular label">{{document?.dateCreated}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Created By <label class="ui circular label">{{document?.createdBy}}</label></div>
		</div>
		<div fxFlex="20%" class="text-right"><a class="ui primary tiny button">View</a></div>
		<div fxFlex class="text-right"><button class="ui light  tiny icon button dropdown" suiDropdown>
			<i class="ellipsis vertical icon"></i>
			<div class="left menu" suiDropdownMenu >
                <div class="item"  (click)="deleteDoc()">Remove</div>
                 <div class="item" >Download </div>
                </div>
		</button></div>
	</div>
	<div class="ui divider"></div>
	</ng-template>

</div>
